import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { PersonType } from '../../../models/quotation-model/catalogs/person-type.model';
import {
  QuoterPersonPaged,
  QuoterPerson,
  QuoterPersonRatificationPaged,
  QuoterPersonRatification,
  QuoterPersonRatificationDealer,
  QuoterPersonRatificationDealerSelect,
} from '../../../models/quotation-model/catalogs/quoterConfig/quoter-person-type.model';
import { CommonFilterRequest, CommonResult } from '../../../models/quotation-model/customer.model';

@Injectable({
  providedIn: 'root',
})
export class PersonTypeService {
  URL_API = environment.apiURL;
  constructor(private http: HttpClient) {}

  getPersonTypes(): Observable<PersonType[]> {
    return this.http.get<PersonType[]>(this.URL_API + '/Person');
  }

  getPersonTypesToProgram(programId: number): Observable<PersonType[]> {
    return this.http.get<PersonType[]>(
      this.URL_API + '/Person/GetPersonTypesToProgram?programId=' + programId,
    );
  }

  getPersonTypesToInsurance(insuranceId: number): Observable<PersonType[]> {
    return this.http.get<PersonType[]>(
      this.URL_API + '/Person/GetPersonsToInsurance?insuranceId=' + insuranceId,
    );
  }

  getPagedPersonTypes(filters: CommonFilterRequest): Observable<QuoterPersonPaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ? filters.filter : '');
    return this.http.get<QuoterPersonPaged>(this.URL_API + '/Person/GetPagedPersonTypes', {
      params,
    });
  }

  upsertQuoterPerson(upsertPerson: QuoterPerson) {
    return this.http.post<CommonResult>(this.URL_API + '/Person/UpsertPerson', upsertPerson);
  }

  getPagedPersonRatifications(
    filters: CommonFilterRequest,
    PersonId: number,
  ): Observable<QuoterPersonRatificationPaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ? filters.filter : '')
      .set('PersonId', PersonId);
    return this.http.get<QuoterPersonRatificationPaged>(
      this.URL_API + '/Person/GetPagedPersonRatifications',
      {
        params,
      },
    );
  }

  upsertQuoterPersonRatification(upsertPersonRatification: QuoterPersonRatification) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Person/UpsertPersonRatification',
      upsertPersonRatification,
    );
  }

  getPersonRatificationDealers(
    ratificationId: number,
  ): Observable<QuoterPersonRatificationDealer[]> {
    return this.http.get<QuoterPersonRatificationDealer[]>(
      this.URL_API + '/Person/GetPersonRatificationDealers?ratificationId=' + ratificationId,
    );
  }

  upsertQuoterPersonRatificationDealer(
    upsertPersonRatificationDealer: QuoterPersonRatificationDealerSelect,
  ) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Person/UpsertPersonRatificationDealer',
      upsertPersonRatificationDealer,
    );
  }
}
